var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WidgetDatatableTabs',{attrs:{"items":_vm.data.data,"defaultTarget":"count","nbTabs":0,"showTotal":_vm.data.showTotal ? _vm.data.showTotal : false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.conf.title))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }